import(/* webpackMode: "eager", webpackExports: ["AddToCartBundle"] */ "/vercel/path0/components/bundles/add-to-cart-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BundleAddToCart"] */ "/vercel/path0/components/bundles/bundle-add-to-cart.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.0.0-canary.113_react-dom@19.0.0-rc-3208e73e-20240730_react@19.0.0-rc-3208e73e-2024073_4xh4g4q6puzpsjuq53kgwaqj2y/node_modules/next/dist/client/image-component.js");
